import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=39d685c0"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d685c0')) {
      api.createRecord('39d685c0', component.options)
    } else {
      api.reload('39d685c0', component.options)
    }
    module.hot.accept("./SocialLogin.vue?vue&type=template&id=39d685c0", function () {
      api.rerender('39d685c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/SocialLogin.vue"
export default component.exports